import React from "react";
import { StyleSheet, View } from "react-native";

import {
  Button,
  CountryPicker,
  Input,
  InputLabel,
  LoadingBox,
  Text,
} from "components";

import { useForm, Controller } from "react-hook-form";

import { strings } from "assets/constants";

import css from "styles";

import { useCreateZone } from "clients/apis";

const CreateZone = () => {
  const {
    control,
    reset,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateZoneReqT>({
    defaultValues: {
      country_id: "",
      name: "",
      slug: "",
      code: "",
    },
  });

  const createZoneMut = useCreateZone();
  const _onSubmit = () =>
    createZoneMut.mutate(getValues(), {
      onSettled(data, error) {
        if (!error) {
          // console.log(data);
          return;
        }

        // console.log(error);
      },
    });

  return (
    <View style={styles.container}>
      <Text weight="extraBold" style={styles.title}>
        {strings.create_new_zone}
      </Text>

      <>
        <InputLabel label={strings.country} />
        <Controller
          control={control}
          name="country_id"
          rules={{ required: { value: true, message: strings.fill_input } }}
          render={({ field: { value, onChange } }) => (
            <CountryPicker onSelect={(c) => onChange(c?.id)} />
          )}
        />
      </>

      <>
        <InputLabel label={strings.zone_name} />
        <Controller
          control={control}
          name="name"
          rules={{ required: { value: true, message: strings.fill_input } }}
          render={({ field: { value, onChange } }) => (
            <Input
              value={value}
              onChangeText={onChange}
              icon={{ name: "edit-2" }}
              placeholder={strings.zone_name}
              error={errors?.name?.message}
            />
          )}
        />
      </>

      <View style={css.rRowCenterAlignSpaceBetween}>
        <View style={{ width: "49%" }}>
          <InputLabel label={strings.zone_slug} />
          <Controller
            control={control}
            name="slug"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => (
              <Input
                value={value}
                onChangeText={onChange}
                icon={{ name: "edit-2" }}
                placeholder={strings.zone_slug}
                error={errors?.slug?.message}
              />
            )}
          />
        </View>

        <View style={{ width: "49%" }}>
          <InputLabel label={strings.zone_code} />

          <Controller
            control={control}
            name="code"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => (
              <Input
                value={String(value)}
                onChangeText={onChange}
                icon={{ name: "edit-2" }}
                placeholder={strings.zone_code}
                error={errors?.code?.message}
              />
            )}
          />
        </View>
      </View>

      <Button
        mt={15}
        width={120}
        title={{ value: strings.create }}
        onPress={handleSubmit(_onSubmit)}
      />
      {createZoneMut?.isLoading && <LoadingBox />}
    </View>
  );
};

export default CreateZone;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 15,
    paddingVertical: 20,
    borderBottomWidth: 5,
    borderTopWidth: 5,
    borderColor: "#edecfb",
  },
  title: { marginBottom: 7 },
});
